import PropTypes from "prop-types";
import React from "react";

import Dimensions from "../../constants/styles/dimensions";
import AppShared from "../../features/app/App.shared";
import { PropTypeShapes } from "../../types";
import preprocessorQuery from "../../utils/preprocessorQuery";
import { withContainerContext } from "../container/ContainerContext";
import { withModalSizeContext } from "./ModalSizeContext";

const ModalBody = props => {
  const leftPadding = Math.max(props.paddingLeft, Dimensions.MODAL_X_PADDING);
  const rightPadding = Math.max(props.paddingRight, Dimensions.MODAL_X_PADDING);
  let style = {
    height: props.fixedHeight ? `${props.fixedHeight}px` : null,
    maxHeight: `${props.maxHeight}px`,
    paddingLeft: `${leftPadding}px`,
    paddingRight: `${rightPadding}px`
  };
  if (props.overflowScroll) {
    style.overflow = "auto";
  }

  const component = (
    <div className="modalBody" style={style}>
      {props.children}
    </div>
  );

  // Mobile modals do not sit inside their own DragDropContainer (tablet gets it from ModalPortal)
  // so we need to wrap it to prevent the drag and drop bleeding through to the underneath.
  if (preprocessorQuery.isIos()) {
    return AppShared.wrapInDragDropContainer(component);
  }

  return component;
};

ModalBody.propTypes = {
  children: PropTypeShapes.elementOrArray,
  // From ModalSizeContext
  maxHeight: PropTypes.number.isRequired,
  fixedHeight: PropTypes.number,

  overflowScroll: PropTypes.bool,

  // from withContainerContext
  paddingLeft: PropTypes.number,
  paddingRight: PropTypes.number
};

export default withContainerContext(withModalSizeContext(ModalBody));
